import React from 'react';
import { 
    Box, 
    Typography, 
    Grid, 
    Card, 
    CardContent, 
    FormControlLabel, 
    Switch 
} from '@mui/material';
import DocumentUploadSection from 'components/onboardingForms/DocumentUploadSection';

export const VenueCapabilitiesStep = ({ 
    servesAlcohol,
    setServesAlcohol,
    providesCatering,
    setProvidesCatering,
    providesInHouseSecurity,
    setProvidesInHouseSecurity,
    documents,
    memoizedHandleDocumentChange,
    errors
}) => {
    // Create the adapter functions that DocumentUploadSection expects
    const handleFileAdd = (documentType, files) => {
        // Only take the first file if multiple are selected
        const fileToAdd = Array.isArray(files) ? files[0] : files;
        memoizedHandleDocumentChange(documentType, [fileToAdd]);
    };

    const handleFileRemove = (documentType, index) => {
        // Since we only allow one file, we can just set to empty array
        memoizedHandleDocumentChange(documentType, []);
    };

    return (
        <Card sx={{ mb: 4 }}>
            <CardContent>
                <Typography variant="h5" gutterBottom>
                    Venue Capabilities
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
                    Select the services your venue provides. Additional documentation may be required.
                </Typography>
                
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={servesAlcohol}
                                    onChange={(e) => setServesAlcohol(e.target.checked)}
                                />
                            }
                            label="Serves Alcohol"
                        />
                        {servesAlcohol && (
                            <Box sx={{ mt: 2, ml: 4 }}>
                                <DocumentUploadSection
                                    documentType="alcoholLicense"
                                    title="Alcohol License"
                                    description="Upload your liquor license or alcohol service permit"
                                    files={documents.alcoholLicense?.files || []}
                                    onFileAdd={handleFileAdd}
                                    onFileRemove={handleFileRemove}
                                    isRequired={true}
                                    acceptedFileTypes={['.pdf', '.jpg', '.jpeg', '.png']}
                                />
                                {errors.alcoholLicense && (
                                    <Typography color="error" variant="caption">
                                        {errors.alcoholLicense}
                                    </Typography>
                                )}
                            </Box>
                        )}
                    </Grid>
                    
                    <Grid item xs={12}>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={providesCatering}
                                    onChange={(e) => setProvidesCatering(e.target.checked)}
                                />
                            }
                            label="Provides Catering"
                        />
                        {providesCatering && (
                            <Box sx={{ mt: 2, ml: 4 }}>
                                <DocumentUploadSection
                                    documentType="cateringLicense"
                                    title="Catering License"
                                    description="Upload your catering license or food service permit"
                                    files={documents.cateringLicense?.files || []}
                                    onFileAdd={handleFileAdd}
                                    onFileRemove={handleFileRemove}
                                    isRequired={true}
                                    acceptedFileTypes={['.pdf', '.jpg', '.jpeg', '.png']}
                                />
                                {errors.cateringLicense && (
                                    <Typography color="error" variant="caption">
                                        {errors.cateringLicense}
                                    </Typography>
                                )}
                            </Box>
                        )}
                    </Grid>
                    
                    <Grid item xs={12}>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={providesInHouseSecurity}
                                    onChange={(e) => setProvidesInHouseSecurity(e.target.checked)}
                                />
                            }
                            label="Provides In-House Security"
                        />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};